import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Game } from '../../models/game.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { gameSelectRippleOptions } from '../../constants/ripple-options.constant';

@Component({
  selector: 'app-game-selection',
  imports: [TranslateModule, MatRippleModule],
  templateUrl: './game-selection.component.html',
  styleUrl: './game-selection.component.scss',
})
export class GameSelectionComponent {
   @Input() games: Game[] = [];
   @Output() selectedGameCode = new EventEmitter<Game>();
   rippleOptions = gameSelectRippleOptions
   get stepNumber() {
    return 3;
  }
  selectGames(gameCode: Game) {
    this.selectedGameCode.emit(gameCode);
  }
}
